import Stack from '@mui/material/Stack';
import { Button, colors, Typography } from '@sweep-io/sweep-design';
import { useState, useCallback } from 'react';
import ConnectToSfDialog from '../../../../pages/get-started/connect-org/ConnectToSfDialog';
import { CtaDialog } from './CtaDialog';
import usePaywall from '../../usePaywall';
import { PaywallSource } from '../../paywallTypes';

interface HeaderWithConnectToSfButtonsProps {
  headerText: string;
  subHeaderText: string;
  imgSrc: string;
  imgAlt: string;
  name: string;
  source: PaywallSource;
}

export const HeaderWithConnectToSfButtons = ({
  headerText,
  subHeaderText,
  imgSrc,
  imgAlt,
  name,
  source,
}: HeaderWithConnectToSfButtonsProps) => {
  const { connectToSfCallback, ctaClickedCallback } = usePaywall();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isCtaDialogOpen, setIsCtaDialogOpen] = useState(false);

  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = useCallback(() => {
    setIsDialogOpen(false);
  }, []);

  return (
    <Stack
      direction="row"
      sx={{
        background: colors.grey[100],
        p: '64px 102px',
        alignItems: 'center',
        width: '100%',
      }}
      justifyContent="center"
    >
      {isDialogOpen && (
        <ConnectToSfDialog
          closeDialog={closeDialog}
          forceProduction={false}
          onFinish={closeDialog}
        />
      )}

      {isCtaDialogOpen && (
        <CtaDialog name={name} source={source} onClose={() => setIsCtaDialogOpen(false)} />
      )}

      <Stack direction="row" sx={{ width: '1080px', gap: 16 }} justifyContent="space-between">
        <Stack gap={4}>
          <Stack gap={1}>
            <Typography variant="h1-bold" color={colors.night[900]}>
              {headerText}
            </Typography>
            <Typography variant="body" color={colors.night[900]}>
              {subHeaderText}
            </Typography>
          </Stack>

          <Stack width="448px">
            <Typography variant="caption-medium" color={colors.night[900]}>
              Ready to try it out?
            </Typography>
            <Stack direction="row" gap={2} pt={1}>
              <Button
                onClick={() => {
                  connectToSfCallback(source);
                  openDialog();
                }}
              >
                Connect to Salesforce
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  ctaClickedCallback(source);
                  setIsCtaDialogOpen(true);
                }}
              >
                Talk to an expert
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <img src={imgSrc} alt={imgAlt} style={{ height: '100%', width: '436px' }} />
      </Stack>
    </Stack>
  );
};
